import React from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";

function StringentQualityTesting() {
  const qualityData = [
    { label: "Fat %", value: "99.9%" },
    { label: "Moisture %", value: "0.3%" },
    { label: "FFA% (As Oleic Acid)", value: "0.5%" },
    { label: "BR Reading at 40°C", value: "41" },
    { label: "RM Value", value: "28" },
    { label: "Total Farmers", value: "44" },
    { label: "Total Milk Collected", value: "346 L" }
  ];

  const { brandData } = useTraceabilityData();
  const brandName = brandData?.logo?.brandName;
  return (
    <div>
      <div class="wrapper2">
        <h2 class="heading2">Stringent Quality Testing</h2>
      </div>
      <section class="py-0">
        <div class="container py-0">
          {/* <!-- more blogs --> */}
          <div class="row g-3">
            <div class="col-lg-4 col-12">
              <p class="card-text text-muted py-3 px-2">
                At {brandName}, quality is non-negotiable. Every batch collected
                is subjected to stringent tests to ensure it meets the highest
                standards of purity and safety. Our grading system leverages
                advanced technology to analyze multiple parameters with
                precision, offering transparency at every stage. This ensures
                that only top-quality milk progresses through the supply chain,
                reinforcing trust and reliability.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div class="wrapper2">
        <br />

        <h2 class="heading2" style={{ textAlign: "left" }}>
          Our Quality Tests
        </h2>
        <div class="underline2  my-3 mx-1"></div>
      </div>
      <div className="bg-white py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
            {qualityData.map((item, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-green-500 to-green-700 rounded-xl p-3 text-white shadow-lg"
              >
                <div className="text-xs text-green-50 mb-1">
                  {item.label}
                </div>
                <div className="text-2xl font-bold">{item.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <div class="container">
        <div class="underline2"></div>
      </div> */}

      {/* <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Manufacturing Insights</h6>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <a href="/technology-at-work">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m5-min.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      <br />
                      Technology At Work
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/stringent-quality-testing">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m2-min.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "14px" }}>
                      <br />
                      Stringent Quality Testing
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/certified-for-excellence">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m3-min.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      <br />
                      Certified for Excellence
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/smart-manufacturing">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/m4-min.png" alt="" className="card-img-top" />
                  <div
                    className="position-absolute text-overlay-f text-white p-3"
                    style={{ top: "30%" }}
                  >
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      <br />
                      <br />
                      Smart Manufacturing
                    </h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> */}
      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/technology-at-work"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/certified-for-excellence"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>
      {/* <Index /> */}
    </div>
  );
}

export default StringentQualityTesting;
